import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FetosensePlusComponent } from './fetosensePlus.component';
import { FetosensePlusRoutingModule } from './fetosensePlus.routing';
import { NgSelectModule } from '@ng-select/ng-select';

import { ComponentsModule } from 'src/app/shared/components/components.module';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';
import { FetosensePlusIntroComponent } from './components/fetosensePlus-intro/fetosensePlus-intro.component';
import { FetosensePlusFeaturesComponent } from './components/fetosensePlus-features/fetosensePlus-features.component';
import { FetosensePlusComponentsComponent } from './components/fetosensePlus-components/fetosensePlus-components.component';
import { FetosensePlusStatsComponent } from './components/fetosensePlus-stats/fetosensePlus-stats.component';
import { FetosensePlusTestimonialsComponent } from './components/fetosensePlus-testimonials/fetosensePlus-testimonials.component';
import { FetosensePlusVideosComponent } from './components/fetosensePlus-videos/fetosensePlus-videos.component';
import { FetosensePlusEnquiryComponent } from './components/fetosensePlus-enquiry/fetosensePlus-enquiry.component';
import { FetosensePlusLocationsComponent } from './components/fetosensePlus-locations/fetosensePlus-locations.component';

@NgModule({
  declarations: [FetosensePlusComponent, FetosensePlusIntroComponent, FetosensePlusFeaturesComponent, FetosensePlusComponentsComponent, FetosensePlusStatsComponent, FetosensePlusTestimonialsComponent, FetosensePlusVideosComponent, FetosensePlusEnquiryComponent, FetosensePlusLocationsComponent],
  imports: [
    CommonModule,
    FetosensePlusRoutingModule,
    ComponentsModule,
    MaterialModule,
    NgSelectModule
  ]
})
export class FetosensePlusModule { }
